import headerImage from "../../assets/images/welcome/bg1.svg";

// Image Section
import imageB1 from "../../assets/images/welcome/b1.svg";
import imageB2 from "../../assets/images/welcome/b2.svg";
import imageB3 from "../../assets/images/welcome/b3.svg";
import imageB4 from "../../assets/images/welcome/b4.svg";
import imageB5 from "../../assets/images/welcome/b5.svg";
import imageB6 from "../../assets/images/welcome/b6.svg";

import fullBurger from "../../assets/images/welcome/full_burger.svg";


// Styles
import "./styles.scss";

function AchieveImage() {
  return (
    <div className="achieve-image-style">
      <div className="image-section">
        {/* <img src={imageB6} alt="" />
        <img src={imageB5} alt="" />
        <img src={imageB4} alt="" />
        <img src={imageB3} alt="" />
        <img src={imageB2} alt="" />
        <img src={imageB1} alt="" /> */}
        <img src={fullBurger} alt="" />
      </div>
    </div>
  );
}

export default AchieveImage;
